export const REMINDER_WEB_INSTALLATION_ID = 'web';

export const getReminderDueTimezone = () => {
    try {
        return Intl.DateTimeFormat().resolvedOptions().timeZone || undefined;
    } catch (error) {
        return undefined;
    }
};
